import { render, staticRenderFns } from "./CurriculumListNECTable.vue?vue&type=template&id=2c15b202&scoped=true&"
import script from "./CurriculumListNECTable.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListNECTable.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListNECTable.vue?vue&type=style&index=0&id=2c15b202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15b202",
  null
  
)

export default component.exports